<template>
  <accordion-item
    :headline-level="'h3'"
    :title="$t('tripPlanner.settings.group.meansOfTransportation')"
    :accordion-button-text="$t('tripPlanner.settings.group.meansOfTransportation')"
    class="accordion__item--flat"
  >
    <template v-if="temporarySettingDiffersFromDefault.mot" #accordion-header>
      <span>
        <span class="trip-setting--changed">{{ $t('tripPlanner.settings.settingChangedText') }}</span>
      </span>
    </template>
    <template #accordion-content>
      <custom-switch-input
        :legend="$t('tripPlanner.settings.group.meansOfTransportation')"
        :hide-legend="true"
        :switch-list="motData"
        class="form__switch-grid"
        @set-optionChanged="toggleMot"
      />

      <hr>

      <basic-control
        :appearance="'link'"
        :icon="'switch'"
        class="toggle-mot-filters"
        @onClick="toggleAllMots"
      >
        {{ lessThanHalfMotActivated ? $t('misc.buttons.setAllMots') : $t('misc.buttons.removeAllMots') }}
      </basic-control>
    </template>
  </accordion-item>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { tripSettingsStore } from '@/stores/tripsettings'
import AccordionItem from '@/partials/accordion-item.vue'
import BasicControl from '@/partials/_buttons/basic-control.vue'
import CustomSwitchInput from '@/partials/_form/switch-input.vue'

export default {
  name: 'TripSettings',
  components: {
    AccordionItem,
    BasicControl,
    CustomSwitchInput
  },
  props: {
    mot: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState(tripSettingsStore, [
      'possibleOptions',
      'temporarySettingDiffersFromDefault'
    ]),
    lessThanHalfMotActivated () {
      return this.mot?.length < (this.possibleOptions?.mot?.length / 2)
    },

    /**
     * Return array to render mot checkboxes.
     * @function motData
     */
    motData () {
      const array = []

      this.possibleOptions?.mot.forEach((mot) => {
        array.push(
          {
            checked: this.mot.includes(mot),
            iconType: 'transportation',
            type: 'checkbox',
            value: mot,
            id: `mot-${mot.toLowerCase()}`,
            label: this.$t(`tripPlanner.mot.${mot}`),
            icon: mot.toLowerCase()
          }
        )
      })

      return array
    }
  },
  watch: {
    mot () {
      this.checkIfTheSettingDiffers('mot')
    }
  },
  mounted () {
    this.checkIfTheSettingDiffers('mot')
  },
  methods: {
    ...mapActions(tripSettingsStore, [
      'checkIfTemporarySettingDiffersFromDefault'
    ]),
    /**
     * Toggle whether or not a mot (transportation vehicles) should be used for travelling.
     * @function toggleMot
     */
    toggleMot () {
      if (event.target.checked) {
        // mot gets added
        this.$emit('motChanged', [...this.mot, event.target.value])
      } else {
        // mot gets removed
        this.$emit('motChanged', this.mot.filter((mot) => mot !== event.target.value))
      }
    },

    /**
     * Toggle all Mot Checkboxes.
     * All will be activated in case there are less than half of all mot activated.
     * Otherwise all will be deactivated.
     * @function toggleAllMots
     */
    toggleAllMots () {
      if (this.lessThanHalfMotActivated) {
        // activate all mot
        this.$emit('motChanged', this.possibleOptions.mot)
      } else {
        // deactivate all mot
        this.$emit('motChanged', [])
      }
    },
    checkIfTheSettingDiffers (settingName) {
      this.checkIfTemporarySettingDiffersFromDefault({
        settingName,
        settingValue: this[settingName]
      })
    }
  }
}
</script>
